import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { FilterProps } from '../Overview';
import noti from 'libs/notification';

export interface OverviewState<T = any> {
  status: string;
  currentPage: number;
  valueSearch: string;
  valuesFilter: FilterProps;
}

const STORAGE_KEY = 'overviewState';

export const useRestoreOverviewState = (
  setStatus: (val: string) => void,
  setCurrentPage: (val: number) => void,
  setValueInput: (val: string) => void,
  setValueSearch: (val: string) => void,
  setValuesFilter: (val: FilterProps) => void,
  setIsRestoringState: React.Dispatch<React.SetStateAction<boolean>>
) => {
  useEffect(() => {
    const storedState = sessionStorage.getItem(STORAGE_KEY);
    if (storedState) {
      try {
        const { status, currentPage, valueSearch, valuesFilter } = JSON.parse(storedState);

        if (status) setStatus(status);
        if (currentPage) setCurrentPage(currentPage);
        if (valueSearch) {
          setValueSearch(valueSearch);
          setValueInput(valueSearch);
        }
        if (valuesFilter) setValuesFilter(valuesFilter);
      } catch (error) {
        noti('error', 'Failed to parse overview state');
      }
    }
    setIsRestoringState(false);
  }, []);
};
export const saveOverviewState = <T>(state: OverviewState<T>) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};

// clear session
const whitelist = ['/candidates/information', '/candidates', '/candidates/create'];
export const ClearSessionOnRouteChange = () => {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    const path = location.pathname;
    const isWhitelisted = whitelist.some((p) => path.startsWith(p));
    if (isFirstLoad.current) {
      const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
      const isReload = navEntry?.type === 'reload';

      if (isReload && !isWhitelisted) {
        sessionStorage.removeItem(STORAGE_KEY);
      }

      isFirstLoad.current = false;
    } else if (!isWhitelisted) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }, [location]);

  return null;
};
